export * from "ce/sagas/draftSages";
import { all, takeLatest } from "redux-saga/effects";
import {
  savePageDraftSaga,
  getPageDraftSaga,
  restorePageDraftSaga,
  deletePageDraftSaga,
} from "ce/sagas/draftSages";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";

export default function* draftSagas() {
  yield all([
    takeLatest(ReduxActionTypes.SAVE_PAGE_DRAFT, savePageDraftSaga),
    takeLatest(ReduxActionTypes.GET_PAGE_DRAFT, getPageDraftSaga),
    takeLatest(ReduxActionTypes.RESTORE_DRAFT, restorePageDraftSaga),
    takeLatest(ReduxActionTypes.DELETE_DRAFT, deletePageDraftSaga),
  ]);
}
